var _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 581.91 828.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 212.84,
    cy: 309.72,
    r: 33.136,
    gradientTransform: "matrix(1.0395 0 0 .96197 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 332.39,
    cy: 528.12,
    r: 51.048,
    gradientTransform: "matrix(1.79 0 0 .55865 66.116 35.426)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#def1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#def1dd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 549.16,
    cy: 195.98,
    r: 45.636,
    gradientTransform: "matrix(.76737 0 0 1.3032 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e2d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e2d8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 311.55,
    cy: 428.99,
    r: 131.03,
    fy: 427.43,
    gradientTransform: "matrix(.96097 0 0 1.0406 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f75248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f75248",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 512.2,
    cy: 400.7,
    r: 48.682,
    fx: 494.86,
    fy: 401.4,
    gradientTransform: "matrix(.89301 0 0 1.1198 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eedfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eedfde",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 352.28,
    cy: 353.78,
    r: 51.192,
    fx: 339.75,
    fy: 375.77,
    gradientTransform: "matrix(.76731 0 0 1.3033 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eedfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eedfde",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(.67036 -.24316 .47818 1.3183 -61.573 178.21)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(.5356 .47078 -.92582 1.0533 334.01 62.744)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(-.41719 -.18104 .30589 -.9549 375.12 863.8)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(-.23793 -.13565 .17445 -.71551 367.99 780.95)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(-.42309 .1668 -.45853 -.89171 619.78 772.27)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(.38002 .24982 -.46492 .8884 359.09 179.73)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(-.11279 -.44057 .94189 -.34387 106.21 767.69)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 503.87,
    cy: 309.08,
    r: 25.789,
    gradientTransform: "matrix(.34764 .11646 -.22813 .66606 259.39 283.09)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 434.43,
    cy: 406.43,
    r: 44.995,
    gradientTransform: "matrix(1.003 0 0 .99706 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9dddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9dddf",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efe1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efe1dd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 179.27,
    x2: 244.42,
    y1: 346.19,
    y2: 395.24,
    gradientTransform: "matrix(1.292 0 0 .77397 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff0de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dff0de",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 126.61,
    x2: 154.05,
    y1: 491.36,
    y2: 467.66,
    gradientTransform: "matrix(1.4507 0 0 .6893 66.116 35.426)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5eee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eee5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 473.52,
    x2: 522.12,
    y1: 213.53,
    y2: 232.17,
    gradientTransform: "matrix(.90522 0 0 1.1047 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f4f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f4f1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 424.87,
    x2: 682.37,
    y1: 178.64,
    y2: 213.04,
    gradientTransform: "matrix(.6664 0 0 1.5006 68.974 38.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eff0ee",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4ebe4e",
    fillRule: "evenodd",
    stroke: "#93e286",
    strokeWidth: 1.01,
    d: "M480.16 351.15c-6.64-3.53-14.92-9.9-22.26-16.84-6.05-5.71-11.86-16.81-16.33-22.44-4.98-6.27-8.24-11.51-10.39-19.65-1.94-7.31-3.97-13.61-5.94-21.04-2.25-8.51-.34-11.73 5.94-19.64 4.79-6.04 3.37-9.82 19.29-9.82 8.07 0 14.21 1.4 22.27 1.4 10.42 0 12.44-1.67 20.78-5.61 5.62-2.66 9.31-9.17 11.88-14.03 2.67-5.05 4.75-10.38 7.42-15.43 2.82-5.33-7.73 9.96-13.36 12.62-6.64 3.14-14.46 4.21-22.27 4.21-6.29 0-12.17-3.93-19.29-5.61-7.19-1.7-12.88-1.4-20.79-1.4-12.15 0-22.39 1.43-34.14 4.21-3.99.94-11.59 5.34-14.84 8.41-4.63 4.38-8.67 9.53-13.36 15.44-5.75 7.24-9.38 5.98-11.88 15.43-1.87 7.1 2.43 14.4 4.46 18.24 3.18 6.01 6.73 10.56 10.39 14.03 5.13 4.84 8.82 12.46 11.87 18.24 3.02 5.69 4.63 12.31 11.88 14.02 3.82.91-2.86 20.84-2.97 21.05-3.15 5.96-1.89 10.33-5.94 15.43",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc949",
    fillRule: "evenodd",
    stroke: "#a3eb9e",
    d: "M340 280.93c-5.28 1.47-15.23-2.61-21.43-5.71-5.29-2.65-13.05-3.67-20-7.14-5.87-2.94-16.5-3.02-22.86-4.29-7.76-1.55-13.46-2.65-20-4.28-8.96-2.25-16.04-6.05-21.42-11.43-6.57-6.57-15.33-11.04-21.43-17.15-5.16-5.16-11.91-19.52-5.72-7.14 3.56 7.12 5.29 14.01 7.15 21.43 1.58 6.32 4.57 13.99 5.71 18.57 1.79 7.18 4.12 10.76 5.71 17.14.81 3.23 12.57 8.28 14.29 10 6.61 6.62 20.29-.51 7.14 10-2.5 2.01 14.71 8.79 17.15 10 5.88 2.95 10.92 6.89 17.14 10 5.54 2.78 11.26 8.41 15.71 12.86 4.67 4.66 9.29 5.18 17.15 7.14 7.51 1.88 12.59 3.87 20 5.72 8.1 2.02 17.01 8.18 24.28 10 8.95 2.23 16.67 3.9 25.72 5.71 9.54 1.91 13.77-2.23 15.71-10 2.47-9.88 1.62-18.18-2.86-27.14-3.8-7.6-9.22-10.52-18.57-12.86-5.66-1.41-13.04-15.9-17.14-20-5.3-5.3-8.38-5.31-15.72-7.14-2.31-.58-3.81-2.86-5.71-4.29z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M300 283.79c-2.23-3.27-13.44-3.72-21.43-5.71-8.73-2.19-14.93-5.52-21.43-7.15-6.46-1.61-12.97-5.05-17.14-7.14-8.58-4.29-9.87-5.58-1.43 2.86 4.42 4.42 9.59 11.01 11.43 12.86 5.61 5.61 8.38 7.8 17.14 10 8.93 2.23 15.47 7.04 22.86 10 7.89 3.15 11.49 7.88 18.57 11.42 5.32 2.66 12.86 6.51 12.86-4.28 0-10.55 3.31-12.63-5.72-17.14-5.47-2.74-8.53-2.13-15.71-5.72z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50c54a",
    fillRule: "evenodd",
    stroke: "#a1ee94",
    d: "M275.71 350.93c-3.57-3.06-11.43-10.71-20-12.85-9.47-2.37-13.8 1.42-21.42 7.14-5.82 4.36-12.4 5.62-20 7.14-7.32 1.47-13.13 2.86-21.43 2.86-6.5 0-13.01-5.87-17.15-10-5.17-5.18-6.12-8.99-10-12.86-4.06-4.07 10.57 4.57 15.72 7.15 8.29 4.14 9.8-2.46 12.86-8.58 2.78-5.56 8.5-9.98 14.28-11.42 6.43-1.61 10.34-2.86 18.57-2.86 8.09 0 15.37 1.43 22.86 1.43 6.13 0 13.91 6.23 18.57 8.57 5.39 2.69 5.92 18.15 7.14 24.28z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M180 340.93c5.05 3.85 13.31 3.84 18.57-1.42 6.01-6.01 9.89-12.09 17.14-15.72 5.19-2.59 11.97.27 17.15 2.86 3 1.5-11.15 9.86-11.43 10-5.59 2.79-9.74 5.58-15.72 8.57-6.27 3.14-11.76 2.86-20 2.86-3.04 0-3.81-4.77-5.71-7.15z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#389538",
    fillRule: "evenodd",
    stroke: "#7ec76e",
    strokeWidth: 0.987,
    d: "M237.73 359.48c-6.08-1.36-14.2-6.94-18.41-16.62-3.46-7.93-8.83-10.25-14.47-15.1-6.2-5.34-9.46-10.96-13.15-16.61-3.22-4.94-8.24-12.89-10.52-18.13-3.28-7.52-3.31-13.55 0-21.14 3.56-8.19 3.93-12.07 7.89-16.61 2.35-2.7 10.82 12.43 11.83 13.59 5.59 6.41 6.12 6.66 14.47 9.06 5.39 1.55 11.22 3.02 17.1 3.02 6.28 0 15.19 2.22 19.48.99 7.17 1.21 11.28 4.64 17.23 4.64 8.62 3.57 13.56 7.02 18.41 9.81 7.47 2.9 11.48 4.38 14.7 8.07 6.79 5.09 8.6 6.76 14.35 12.33 5.93 4.2 7.7 5.87 13.15 9.47 4.57 5.25 5.76 9.64 9.21 13.59 5.05 5.8 5.33 8.35 11.83 12.08 3.03 1.74 6.81 3.16 9.21 4.54",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "M191.43 263.79c3.05 5.89 5.32 12.4 12.86 14.29 4.15 1.04 10.61 8.16 14.28 10 4.5 2.25 16.26 0 21.43 0 5.66 0 10.57 9.7 12.86 14.28 3.81 7.63-1.14 13.99-4.29 17.15-5.54 5.53-8.97 8.57-17.14 8.57-6.37 0-11.32-4.95-15.72-7.15-7.64-3.82-13.9-4.35-21.42-10-5.29-3.96-7.17-11.53-8.58-17.14-1.99-7.97-.72-12.84 2.86-20 2.52-5.03 1.22-1.81 2.86-10z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ebe4e",
    fillRule: "evenodd",
    stroke: "#96dd90",
    d: "M452.86 353.79c4.85-2.44 12.68-11.08 15.71-17.14 2.34-4.69 8.4-9.83 11.43-12.86 4.44-4.44 11.3-11.17 14.29-17.14 3.96-7.92 5.71-8.51 5.71-18.57 0-7.92-.2-14.7-2.86-20-4.09-8.18-6.3-10.59-12.85-17.15-4.22-4.21-10.6-7.23-14.29-10-5.16-3.87-10.02-4.29-15.71-7.14-5.3-2.65-13.95-5.79-18.58-8.57-5.38-3.23-11.67-13.35-14.28-18.57-3.65-7.3-5.3-11.21-7.14-18.57-2.16-8.64-2.86 8.7-2.86 12.85 0 7.32-.41 12.67 1.43 20 1.85 7.41 5.93 13.08 10 17.15 5.42 5.41 6.59 9.45 11.43 14.28 6.12 6.13 8.02 9.24 10 17.15 2.06 8.24 3.43 14.82 1.42 22.85-1.85 7.44-8.8 14.52-14.28 20-5.52 5.52-9.55 11.05-11.43 18.57-1.98 7.94-3.04 9.63 0 15.72 1.44 2.87 3.3 6.6 4.29 8.57",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc1837",
    fillRule: "evenodd",
    stroke: "#ec7171",
    strokeWidth: 1.01,
    d: "M368.41 357.18c363.37-61.16 217.72 227.73 185.31 283.18-30.46 71.44-22.83 63.18-72.82 136.09-34.41 47.16-41.36 60.62-94.98 67.44-48.83 8.95-130.69-116.69-143.95-136.18-34.19-34.4-78.87-86.28-98.95-144.58-14.51-89.64 3.25-153 50.02-193.35 66.31-41.85 175.37-12.6 175.37-12.6z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M442.86 232.36c.51 1.03 17.07 8.54 20 10 6.86 3.43 9.99 7.14 14.28 11.43 5.19 5.19 5.28 11.12 7.15 18.57 2.08 8.33.59 13.69-4.29 18.57-4.27 4.27-14.31 2.5-18.57 1.43-6.56-1.64-5.72-17.78-5.72-22.85 0-7.19-7.6-16.64-10-21.43-7.12-14.25-4.52-8.81-14.28-18.57-4.99-4.99-11.04-12.67 0-7.15 6.1 3.05 4.99 3.56 11.43 10z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#479f47",
    fillRule: "evenodd",
    stroke: "#9ae69a",
    d: "M402.86 363.79c-6.01-4.72-4.31-12.82-1.43-18.57 3.88-7.77 10-10.44 10-20 0-7.25-6.09-15.04-8.57-20-2.87-5.74-9.86-12.71-14.29-17.14-4.96-4.96-8.46-9.79-11.43-15.72-3.15-6.31-4.13-10.82-5.71-17.14-2.19-8.74 1.15-14.01 5.71-18.57 5.62-5.62 11.08-12.5 2.86-4.29-4.14 4.14-11.45 5.72-17.14 7.15-6.88 1.71-12.37 5.59-18.57 7.14-4.06 1.01-7.15 12.86-8.58 15.71-2.44 4.9.62 16.76 1.43 20 1.56 6.24 5.16 12.3 8.57 15.72 5.31 5.3 9.02 10.33 14.29 14.28 6.31 4.73 7.16 8.61 10 14.29 3.27 6.55 4.29 12.3 4.29 20 0 6.99 4.62 11.77 8.57 15.71 3.9 3.91 15.73 2.28 20 1.43z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M361.43 252.36c.96.96 0 17.88 0 24.29 0 8.3 4.71 13.28 8.57 17.14 5.62 5.62 8.85 7.42 15.71 14.29 6.13 6.12 5.17 10.64 7.15 18.57 1.55 6.23 0 14.97 0 21.43 0 .97-6.39-12.7-7.15-15.72-1.99-7.96-3.74-8.92-7.14-15.71-3.43-6.87-6.15-9.01-10-12.86-3.13-3.13-9.84-6.67-14.28-10-4.86-3.64-2.86-13.56-2.86-20 0-11.02 1.51-12.94 10-21.43z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#49ae42",
    fillRule: "evenodd",
    stroke: "#8fe38a",
    d: "M531.43 359.51c-6.16-4.6-8.57-12.54-8.57-24.29 0-8.74 1.31-15.49 4.28-21.43 2.9-5.79 11.71-7.14 18.57-7.14 7.48 0 14.69 1.53 20 2.86 6.23 1.55 14.97 0 21.43 0 7.64 0 15.82-8.79 18.57-14.29 3.74-7.47 7.75-14.07 11.43-21.43 2.96-5.91 1.43-18.97 1.43-4.28 0 3.59-11.43 10-12.86 11.42-3.96 3.97-15.84 4.29-21.42 4.29-7.86 0-14.9 1.59-22.86 0-8.84-1.77-16.15-2.86-25.72-2.86H510c-9.47 0-16.06 1-24.29 4.29-7.56 3.02-13.05 8.76-17.14 12.86-7.28 7.28-9.18 9.78-12.86 17.14-2.72 5.44-1.37 15.49-2.85 21.43-2.54 10.14 1.67 12.26 8.57 15.71 6.28 3.14 14.58 2.57 21.43 4.29 6.23 1.55 14.97 0 21.43 0 8.21 0 12.72 1.43 20 1.43h7.14z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M541.43 288.08c4.16.44 14 5.28 21.43 7.14 6.97 1.74 17.06 0 24.28 0 9.37 0 9.63-2.78 11.43-10 .01-.04.29 6.85-5.71 12.86-3.59 3.59-12.91 3.22-17.15 4.28-6.23 1.56-14.97 0-21.42 0-10.8 0-12.86-2.8-12.86-14.28z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M417.14 278.08c-2.94-5.16-11.52-17.24-15.71-21.43-4.25-4.25 9.95-15.33 14.28-18.57 8.77-6.58 5.5-4.29-5.71-4.29-8.16 0-11.94 11.02-14.29 15.72-4 8 2.22 13.64 5.72 17.14 5.35 5.34 7.66 8.21 15.71 11.43z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1b37",
    fillRule: "evenodd",
    d: "M269.228 226.624c10.155-.602 18.982 5.876 30.828 11.3 10.493 4.796 34.1 24.784 39.062 33.886 5.386 9.856 25.466 20.289 32.892 33.873 6.22 11.413 8.224 17.44 8.224 32.003 0 15.58-8.211 31.023-14.394 45.185-10.409 23.83-33.327 45.563-53.444 63.993-3.103 2.838-5.482 6.278-8.223 9.417s-5.482 6.277-8.223 9.403c-11.073 12.68-24.959 24.746-37.01 35.77-16.688 15.291-26.722 23.276-26.722 39.535 0 14.664-39.256 33.56-49.326 48.94-6.484 9.893-15.046 18.141-20.564 28.236-4.89 8.951-4.105 18.38-4.105 30.12 0 13.006 6.303 19.083 12.328 30.119 4.6 8.411 11.242 17.815 18.499 24.47 8.271 7.57 16.53 22.686 22.617 30.119 8.814 10.747 15.975 21.38 24.669 31.99 6.472 7.897 10.952 17.564 16.446 22.599 7.788 7.131 14.985 13.584 22.604 18.82 7.571 5.198 11.604 10.646 22.617 13.17 10.143 2.323 21.24 2.197 30.84 0 11.652-2.662 22.942-11.525 30.827-16.937 10.602-7.282 15.854-16.397 22.616-22.586 8.561-7.847 14.539-19.021 20.552-26.353 5.748-7.018 12.256-14.915 16.446-22.587 5.446-9.968 9.358-19.585 16.446-28.236 4.806-5.875 10.554-21.707 12.34-28.236 2.21-8.136 11.279-16.912 14.382-22.586 5.772-10.584 10.904-19.975 16.446-30.12 5.808-10.634 11.182-24.03 14.394-35.769 3.14-11.488 9.056-22.247 14.381-32.003 5.047-9.215 10.409-23.05 12.34-30.12 3.044-11.135 15.143-23.464 18.5-35.756 2.74-10.056 7.534-18.18 10.275-28.236 2.584-9.466 4.118-22.21 4.118-30.12 0-9.026 3.731-21.23 6.158-30.119 3.32-12.166 6.17-23.453 6.17-35.77 0-12.63.7-21.732-6.17-30.119-5.663-6.917-7.776-20.15-14.381-28.236-6.919-8.437-10.976-18.217-16.446-28.223-6.75-12.354-15.734-16.297-24.67-24.483-10.058-9.215-23.835-13.07-34.944-20.703-8.73-5.989-17.232-8.65-28.775-11.287-15.263-3.503-29.077-7.533-45.233-7.533h-88.389c-19.719 0-29.922 13.17-47.286 13.17"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M274.29 588.08c8.16 1.67 18.25-.48 27.14-7.15 12.21-9.15 25.1-18.54 37.14-28.57 10.99-9.16 20.54-15 28.57-25.71 7.5-9.99 12.86-18.91 12.86-31.43 0-8.17 1.43-18.09 1.43-27.14 0-17.18-7.51-30.03-11.43-45.72-2.94-11.76-17.8-22.27-24.29-27.14-14.13-10.6-51.04-8.57-67.14-8.57-19.16 0-33.75 7.86-50 17.14-15.17 8.67-23.39 11.36-32.86 27.14-6.03 10.05-5.71 24.14-5.71 35.72 0 20.16 7.56 36.39 11.43 55.71 3.41 17.06 19.13 47.71 31.43 60 6.21 6.21 13.67 11.43 21.43 11.43 6.31 0 13.39-4.06 20-5.71z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    d: "M455.71 408.08c5.03-.02 18.5 12.1 25.72 15.71 11.09 5.55 11.83 17.74 14.28 30 3.06 15.26.34 20.82-10 28.57-10.02 7.52-19.69 16.56-30 24.29-10.16 7.62-17.17-17.26-18.57-22.86-2.67-10.7-7.78-16.35-15.71-24.28-10.55-10.55 1.5-19.73 2.86-21.43 1.15-1.45 7.52-10.39 14.28-17.15 7.91-7.9 12.05-.11 17.14-12.85z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillRule: "evenodd",
    d: "M264.29 420.93c2.92 6.02 8.89 13.66 17.14 15.72 7.66 1.91 11.43 11.15 11.43 20 0 8.11-1.32 15.15-2.86 22.86-1.2 6.02 5.9 20.37 8.57 25.71 5.29 10.59-5.66 17.12-12.86 20-11.88 4.75-30.34-22.79-32.85-32.86-2.2-8.78-12.18-13.74-14.29-24.28-2.22-11.12 7.44-17.72 14.29-22.86 7.09-5.32 12.35-9.33 17.14-15.71 2.06-2.75-3.29-6.15-5.71-8.58z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d96661",
    fillRule: "evenodd",
    stroke: "#000",
    d: "M270.71 461.65c-8.91-.22-8.62 6.4-1.42 10 12.26 6.13-5.75-12.87 8.57-7.14 2.38.95-4.76-1.91-7.15-2.86zM216.71 445.32c-8.91-.22-8.62 6.4-1.43 10 12.27 6.13-5.74-12.87 8.58-7.14 2.38.95-4.77-1.91-7.15-2.86zM225.28 555.32c-8.91-.22-8.62 6.4-1.42 10 12.26 6.13-5.75-12.87 8.57-7.14 2.38.95-4.76-1.91-7.15-2.86zM205.28 511.03c-8.91-.22-8.62 6.41-1.42 10 12.26 6.13-5.75-12.86 8.57-7.14 2.38.95-4.76-1.9-7.15-2.86zM321 592.46c-8.92-.22-8.62 6.41-1.43 10 12.26 6.13-5.74-12.87 8.57-7.14 2.38.95-4.76-1.91-7.14-2.86zM279.57 513.89c-8.92-.22-8.62 6.4-1.43 10 12.26 6.13-5.74-12.87 8.57-7.14 2.38.95-4.76-1.91-7.14-2.86zM253.86 671.03c-8.92-.22-8.62 6.41-1.43 10 12.26 6.13-5.75-12.86 8.57-7.14 2.38.95-4.76-1.9-7.14-2.86z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#c90e2d",
    fillRule: "evenodd",
    stroke: "#000",
    d: "M567.14 470.93c9.41 5.46 8.72 11.43-4.28 11.43-4.07 0 1.74-8.25 4.28-11.43zM532.52 416.65c9.41 5.45 8.72 11.43-4.29 11.43-4.06 0 1.75-8.26 4.29-11.43zM509.66 522.36c9.41 5.45 8.72 11.43-4.28 11.43-4.07 0 1.74-8.25 4.28-11.43zM463.95 662.36c9.4 5.45 8.72 11.43-4.29 11.43-4.07 0 1.75-8.25 4.29-11.43zM399.66 688.08c9.41 5.45 8.72 11.43-4.28 11.43-4.07 0 1.74-8.26 4.28-11.43zM522.52 593.79c9.41 5.45 8.72 11.43-4.29 11.43-4.06 0 1.75-8.25 4.29-11.43zM439.66 772.36c9.41 5.45 8.72 11.43-4.28 11.43-4.07 0 1.74-8.25 4.28-11.43zM448.23 596.65c9.41 5.45 8.72 11.43-4.28 11.43-4.07 0 1.74-8.26 4.28-11.43zM341.09 765.22c9.41 5.45 8.72 11.43-4.28 11.43-4.07 0 1.74-8.25 4.28-11.43zM332.52 685.22c9.41 5.45 8.72 11.43-4.29 11.43-4.06 0 1.75-8.25 4.29-11.43z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M401.29 645.79c-9.03-1.28-11.6 7.1 0 10 11.5 2.87.37-9.78 0-10zM452.71 714.36c-9.02-1.28-11.6 7.1 0 10 11.5 2.87.38-9.78 0-10zM405.57 750.07c-9.03-1.27-11.6 7.1 0 10 11.5 2.88.37-9.77 0-10zM405.57 790.07c-9.03-1.27-11.6 7.1 0 10 11.5 2.88.37-9.77 0-10z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ac6d59",
    fillRule: "evenodd",
    stroke: "#000",
    d: "M518.57 648.08c9.43-10.9-9.54-15.9 0 0zM458.6 561.72c9.43-10.9-9.54-15.9 0 0zM401.46 617.43c9.42-10.9-9.54-15.9 0 0zM370.03 693.14c9.42-10.89-9.54-15.9 0 0zM365.74 748.86c9.43-10.9-9.54-15.9 0 0zM331.46 738.86c9.42-10.9-9.54-15.9 0 0zM327.17 673.14c9.43-10.89-9.54-15.9 0 0zM412.89 721.72c9.42-10.9-9.54-15.9 0 0zM380.03 808.86c9.42-10.9-9.54-15.9 0 0zM285.74 724.57c9.43-10.89-9.54-15.9 0 0zM541.46 548.86c9.42-10.9-9.54-15.9 0 0zM534.31 476c9.43-10.89-9.54-15.9 0 0zM490.03 401.72c9.42-10.9-9.54-15.9 0 0zM457.17 454.57c9.43-10.89-9.54-15.9 0 0zM454.31 491.72c9.43-10.9-9.54-15.9 0 0zM418.6 443.14c9.43-10.89-9.54-15.9 0 0zM338.6 394.57c9.43-10.89-9.54-15.9 0 0zM215.74 410.29c9.43-10.9-9.54-15.9 0 0zM170.03 494.57c9.42-10.89-9.54-15.9 0 0zM205.74 584.57c9.43-10.89-9.54-15.9 0 0zM261.46 616c9.42-10.89-9.54-15.9 0 0zM377.17 514.57c9.43-10.89-9.54-15.9 0 0zM297.17 573.14c9.43-10.89-9.54-15.9 0 0zM335.74 488.72c9.43 10.9-9.54 15.9 0 0zM388.6 577.43c9.43-10.9-9.54-15.9 0 0zM405.74 501.72c9.43-10.9-9.54-15.9 0 0zM280.03 434.57c9.42-10.89-9.54-15.9 0 0zM334.31 450.29c9.43-10.9-9.54-15.9 0 0zM511.46 688.86c9.42-10.9-9.54-15.9 0 0zM481.46 757.43c9.42-10.9-9.54-15.9 0 0z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#c1694e",
    fillRule: "evenodd",
    stroke: "#000",
    d: "M488.57 699.51c-5.68-1.99-13.51 7.33-2.86 10 9.74 2.43 6.66-4.93 2.86-10zM495.1 627.26c-5.68-1.99-13.51 7.34-2.85 10 9.73 2.43 6.66-4.93 2.85-10zM305.1 418.69c-5.68-1.99-13.51 7.33-2.85 10 9.73 2.43 6.66-4.93 2.85-10zM237.96 475.83c-5.68-1.99-13.51 7.34-2.86 10 9.74 2.44 6.66-4.93 2.86-10zM246.53 405.83c-5.68-1.99-13.51 7.34-2.86 10 9.74 2.44 6.66-4.93 2.86-10zM322.25 474.4c-5.69-1.98-13.52 7.34-2.86 10 9.73 2.44 6.66-4.93 2.86-10zM250.82 508.69c-5.68-1.99-13.51 7.33-2.86 10 9.73 2.43 6.66-4.93 2.86-10zM275.1 558.69c-5.68-1.99-13.51 7.33-2.85 10 9.73 2.43 6.66-4.93 2.85-10zM576.53 400.12c-5.68-1.99-13.51 7.33-2.86 10 9.74 2.43 6.66-4.93 2.86-10zM533.67 380.12c-5.68-1.99-13.51 7.33-2.85 10 9.73 2.43 6.66-4.93 2.85-10zM450.82 382.97c-5.68-1.98-13.51 7.34-2.86 10 9.73 2.44 6.66-4.92 2.86-10z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    fillRule: "evenodd",
    d: "M349.46 407.5c7.79-.95 10.41 3.57 13.91 13.2 2.66 7.35-.12 14.97-4.9 20.01-9.75 10.27-5.66-1.15-5.12-5.74.95-8.18-.45-12.8.38-19.9.21-1.78-4.26-7.55-4.27-7.57z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    fillRule: "evenodd",
    d: "M261.3 574c4.58 6.37 1.89 10.84-4.88 18.53-5.16 5.88-13.17 7.1-19.9 5.34-13.69-3.61-1.71-5.52 2.57-7.26 7.63-3.1 11.01-6.54 17.63-9.23 1.66-.68 4.58-7.37 4.58-7.38z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    fillRule: "evenodd",
    d: "M186.1 451.39c-4.09-3.14-3.51-6.88-1.28-13.85 1.71-5.33 6.11-8.24 10.43-8.77 8.79-1.1 2.22 3.29.11 5.58-3.76 4.08-4.97 7.3-8.23 10.84-.82.89-1.03 6.19-1.03 6.2z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    fillRule: "evenodd",
    d: "M230.55 462.33c-2.33-2.35-2-5.15-.73-10.38.98-3.99 3.49-6.17 5.95-6.57 5.01-.82 1.27 2.47.06 4.19-2.14 3.05-2.83 5.46-4.69 8.12-.47.66-.59 4.63-.59 4.64z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    fillRule: "evenodd",
    d: "M201.45 554.17c-5.11.67-7.34-2.38-10.69-8.9-2.56-4.97-1.5-10.14 1.18-13.57 5.44-6.99 3.9.76 4.03 3.87.22 5.54 1.64 8.67 1.83 13.48.05 1.21 3.65 5.11 3.65 5.12z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    fillRule: "evenodd",
    d: "M344.31 530.61c3.49 3.8 2.28 7.38-1.11 13.87-2.6 4.95-7.43 7.06-11.78 6.85-8.85-.42-1.62-3.63.85-5.52 4.4-3.38 6.14-6.34 9.96-9.27.96-.73 2.08-5.92 2.08-5.93z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    fillRule: "evenodd",
    d: "M259.18 405.17c-.03-5.16 3.28-6.99 10.16-9.5 5.25-1.92 10.25-.22 13.32 2.85 6.26 6.28-1.24 3.78-4.35 3.52-5.52-.47-8.8.55-13.6.14-1.21-.1-5.52 2.98-5.53 2.99z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    fillRule: "evenodd",
    d: "M298.38 500.81c3.44 2.09 3.05 4.68 1.39 9.54-1.28 3.72-4.83 5.82-8.37 6.28-7.2.94-1.91-2.23-.23-3.86 3-2.89 3.91-5.14 6.51-7.65.65-.64.69-4.3.7-4.31z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9dddf",
    fillRule: "evenodd",
    d: "M492.82 297.736c8.586-4.344 16.266-.515 24.15 3.59 6.908 3.591 1.691 16.222 0 19.725-5.916 12.316-5.167-9.517-5.167-14.338 0-8.764-10.578-7.232-18.982-8.977z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    fillRule: "evenodd",
    d: "M425.74 416.68c-3.48-7.09-.44-13.47 2.81-20 2.85-5.73 12.92-1.43 15.72-.04 9.81 4.88-7.58 4.3-11.42 4.31-6.98.02-5.73 8.77-7.11 15.73z",
    transform: "matrix(1.2075 0 0 1.2555 -166.124 -232.537)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9dddf",
    fillRule: "evenodd",
    d: "M404.444 292.538c5.965-7.746 14.502-7.696 23.317-7.508 7.704.176 8.187 13.924 8.114 17.841-.29 13.76-8.597-6.315-10.59-10.672-3.598-7.922-12.521-1.82-20.841.34zM371.43 459.834c-2.257 6.955-8.041 9.554-14.054 12.14-5.265 2.26-8.767-6.654-9.612-9.253-2.97-9.165 7.281 1.507 9.624 3.767 4.262 4.105 8.911-2.662 14.043-6.654zM425.962 400.348c3.924 9.04 0 16.912-4.178 24.984-3.66 7.069-15.65 1.256-18.97-.59-11.653-6.528 9.322-5.097 13.958-4.946 8.417.263 7.258-10.773 9.19-19.448zM413.404 602.057c2.161 5.674-.653 10.32-3.647 15.078-2.62 4.168-10.107.15-12.16-1.105-7.233-4.444 6.183-2.737 9.153-2.473 5.398.502 5.072-6.277 6.654-11.5zM478.97 495.54c2.174 5.662-.64 10.32-3.634 15.079-2.62 4.168-10.107.15-12.16-1.118-7.244-4.432 6.171-2.737 9.141-2.46 5.41.489 5.084-6.29 6.654-11.501zM411.701 511.673c2.173 5.675-.652 10.333-3.647 15.091-2.62 4.169-10.094.15-12.16-1.117-7.232-4.445 6.183-2.737 9.154-2.46 5.397.489 5.083-6.29 6.653-11.514zM370.296 545.76c2.173 5.662-.64 10.32-3.635 15.079-2.62 4.168-10.107.15-12.16-1.118-7.244-4.432 6.171-2.737 9.141-2.46 5.41.489 5.084-6.29 6.654-11.501zM518.65 391.51c2.173 5.674-.653 10.32-3.647 15.078-2.62 4.168-10.095.15-12.16-1.105-7.233-4.444 6.182-2.737 9.153-2.473 5.397.502 5.084-6.278 6.653-11.5zM370.356 703.087c-11.205 14.036 10.276 17.815 0 0zM275.7 768.837c-11.193 14.037 10.288 17.816 0 0zM339.529 784.983c-11.194 14.036 10.276 17.803 0 0zM318.832 734.763c-11.193 14.036 10.276 17.803 0 0zM225.686 709.653c-11.206 14.036 10.275 17.803 0 0zM256.73 654.047c-11.193 14.036 10.276 17.815 0 0zM184.28 652.252c-11.193 14.036 10.276 17.815 0 0zM389.555 645.083c-11.193 14.036 10.276 17.803 0 0zM467.186 582.308c-11.206 14.036 10.275 17.803 0 0zM349.877 578.717c-11.194 14.036 10.276 17.815 0 0zM241.202 589.477c-11.194 14.036 10.276 17.815 0 0zM237.76 546.438c-11.205 14.036 10.276 17.803 0 0zM154.95 585.32c-11.193-14.036 10.288-17.815 0 0zM298.136 514.147c-11.206 14.036 10.275 17.815 0 0zM449.93 334.786c-11.193 14.049 10.276 17.815 0 0zM446.477 254.082c-11.194 14.037 10.276 17.816 0 0zM391.282 243.323c-11.193 14.036 10.276 17.803 0 0zM322.286 259.456c-11.206 14.049 10.275 17.815 0 0zM182.554 461.566c-11.194-14.036 10.276-17.815 0 0zM48.002 476.482c-11.194 14.036 10.276 17.815 0 0zM101.482 524.906c-11.193 14.05 10.276 17.816 0 0zM508.579 456.758c-11.194 14.036 10.276 17.803 0 0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae714b56.svg";
export { ForwardRef as ReactComponent };